// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-loader[data-v-f2fdb4c2]{height:100%}.app-loader[data-v-f2fdb4c2],.app-loader__inner[data-v-f2fdb4c2]{display:flex;flex-direction:column;align-items:center;justify-content:center}.icon-spinner-white[data-v-f2fdb4c2]{color:#fff!important}", ""]);
// Exports
module.exports = exports;
